import { Outlet, Navigate } from "react-router-dom";

import { AuthHelper } from "../helpers/auth.helper";

export const PrivateRoutes = () => {
    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;
    const isGuestTokenValid = AuthHelper.isGuestTokenValid().result;

    return (
        isAuthTokenValid || isGuestTokenValid
            ? <Outlet />
            : <Navigate to="/auth/sign-in" />
    );
};